import { C100Row } from '../../_types/carnivore100.type'
import { LIST_NAME } from '../../components/carnivore100/list-name'

// The list as a watchlist import: one ticker per line, no header row and no
// other columns. Broker and charting importers (TradingView, thinkorswim,
// Yahoo) all read a bare symbol list, and the ones that don't skip a heading
// would import "Symbol" as a phantom position. No trailing newline either —
// the same importers turn a blank final line into a blank symbol.
export function tickerCsv(rows: C100Row[]): string {
  return rows
    .map(r => r.ticker.trim().toUpperCase())
    .filter(Boolean)
    .join('\n')
}

// `Carnivore 33` -> `carnivore-33`, so renaming the list renames the file with
// it rather than leaving the old branding on every subscriber's download.
function slugify(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

// The date the list was published, not the date it was downloaded: pulling
// yesterday's list today should still name the file after the list. Falls back
// to now when the payload has no usable timestamp.
export function publishedOn(updatedAt?: string | null, now: Date = new Date()): Date {
  if (!updatedAt) return now
  const d = new Date(updatedAt)
  return Number.isNaN(d.getTime()) ? now : d
}

// e.g. `carnivore-33-09-02.csv`. Month-day only: subscribers keep a handful of
// recent lists side by side, and the year is noise at that range.
export function exportFileName(date: Date, listName: string = LIST_NAME): string {
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${slugify(listName)}-${mm}-${dd}.csv`
}

export function downloadCsv(fileName: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
